import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "container-content" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-12" }
const _hoisted_4 = {
  key: 0,
  class: "spell-checking-suggestions"
}
const _hoisted_5 = { class: "visually-hidden" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "visually-hidden" }

import { inject, ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'NoResults',
  props: {
    spellCheckingSuggestions: {}
  },
  emits: ["search"],
  setup(__props: any, { emit }) {

const props = __props;





const i18n = inject('i18n') as { [key: string]: string };
const searchTerm = ref(props.spellCheckingSuggestions);

function search (searchTerm: string): void {
    emit('search', searchTerm);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", null, _toDisplayString(_unref(i18n).noResults), 1 /* TEXT */),
        (_ctx.spellCheckingSuggestions.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createTextVNode(_toDisplayString(_unref(i18n).didYouMean) + " ", 1 /* TEXT */),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.spellCheckingSuggestions, (spellCheckingSuggestion) => {
                return (_openBlock(), _createElementBlock(_Fragment, { key: spellCheckingSuggestion }, [
                  _createElementVNode("span", _hoisted_5, _toDisplayString(spellCheckingSuggestion), 1 /* TEXT */),
                  _createElementVNode("button", {
                    onClick: ($event: any) => (search(spellCheckingSuggestion))
                  }, [
                    _createElementVNode("span", _hoisted_7, _toDisplayString(_unref(i18n).searchFor) + ": ", 1 /* TEXT */),
                    _createTextVNode(" " + _toDisplayString(_unref(i18n).openingQuote + spellCheckingSuggestion + _unref(i18n).closingQuote), 1 /* TEXT */)
                  ], 8 /* PROPS */, _hoisted_6)
                ], 64 /* STABLE_FRAGMENT */))
              }), 128 /* KEYED_FRAGMENT */)),
              _createTextVNode("? ")
            ]))
          : _createCommentVNode("v-if", true)
      ])
    ])
  ]))
}
}

})